<template>
  <section class="ts-hero d-flex flex-column justify-content-end">
    <img
      class="ts-hero-image w-100 h-100 object-fit-cover"
      :class="imageClass"
      :src="image"
      :alt="alt"
      width="1600"
      height="656"
      loading="eager"
      fetchpriority="high"
    />
    <div class="ts-hero-overlay" aria-hidden="true"></div>
    <div class="container ts-hero-inner d-flex flex-column flex-grow-1 justify-content-center text-center">
      <div class="ts-hero-copy mx-auto w-100">
        <h1 v-if="title" class="fw-bold mb-1">{{ title }}</h1>
        <div v-if="subline" class="ts-hero-subline fw-medium">{{ subline }}</div>
        <div class="talentspace-hero-stats" :class="{ 'mt-4': subline, 'mt-2': title && !subline }">
          <!-- A stat with a link leads to its section (welcome page); without one it is a plain counter -->
          <component
            :is="stat.link ? 'router-link' : 'div'"
            v-for="stat in stats"
            :key="stat.label"
            :to="stat.link"
            class="talentspace-hero-stat text-reset text-decoration-none"
          >
            <div class="talentspace-hero-stat-number">
              <ts-animated-count :count="stat.count" />
            </div>
            <!-- Labels are portal translations and may contain markup, as in the legacy banner -->
            <div class="talentspace-hero-stat-label" v-html="stat.label"></div>
          </component>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';
import TsAnimatedCount from '@/components/Talentspace/blocks/TsAnimatedCount.vue';

export interface HeroStat {
  count: number
  label: string
  link?: string | Location
}

@Component({
  components: { TsAnimatedCount },
})
export default class TsPageHero extends Vue {
  // Design class of the photo (its crop, e.g. ts-personal-hero-image)
  @Prop({ default: '' }) readonly imageClass!: string;

  @Prop({ required: true }) readonly image!: string;

  @Prop({ default: '' }) readonly alt!: string;

  @Prop({ default: () => [] }) readonly stats!: HeroStat[];

  @Prop({ default: '' }) readonly title!: string;

  @Prop({ default: '' }) readonly subline!: string;
}
</script>
